import { GET_VENDOR_PLAN_LIST, GET_VENDOR_PLAN_DETAIL,UPDATE_VENDOR_PLAN_DETAIL, REVOKE_VENDOR_PLAN_DETAIL } from "../../utils/constants";


const initialState = {
    vendorPlanList: [],
    vendorPlanDetails: []
};

function getVendorPlanListReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_VENDOR_PLAN_LIST:
            return {
                ...state,
                vendorPlanList: payload.data?.vendorPlanList || []
            };

        case GET_VENDOR_PLAN_DETAIL:
            return {
                ...state,
                vendorPlanDetails: payload.data?.vendorPlanDetails || []
            };
        case UPDATE_VENDOR_PLAN_DETAIL:
            return {
                ...state,
                vendorPlanDetails: payload.data?.vendorPlanDetails || []
            };
        case REVOKE_VENDOR_PLAN_DETAIL:
            return {
                ...state,
                vendorPlanDetails: payload.data?.vendorPlanDetails || []
            };

        default:
            return state;
    }
};

export default getVendorPlanListReducer